module.exports = __webpack_public_path__ + "assets/img/warning.950d4068.svg";